import Twemoji from "react-twemoji";
import { ReactNode } from "react";
import "./Region.css";

const atollIslandIdMap: Record<string, number | null> = {
  red: 0,
  "red-orange": 1,
  orange: 2,
  "orange-yellow": 3,
  yellow: 4,
  "yellow-green": 5,
  green: 6,
  "blue-green": 7,
  blue: 8,
  "blue-violet": 9,
  violet: 10,
  "red-violet": 11,
};
const atollIslandNames: Record<string, string> = {
  red: "Island",
  "red-orange": "Island",
  orange: "Island",
  "orange-yellow": "Island",
  yellow: "Island",
  "yellow-green": "Island",
  green: "Island",
  "blue-green": "Island",
  blue: "Island",
  "blue-violet": "Island",
  violet: "Island",
  "red-violet": "Island",
  "the sea": "Sea",
};

const introMap: Record<string, string> = {
  forest: "forest",
  mountain: "mountain",
  meteorite: "meteorite",
  cave: "cave",
  beach: "beach",
};
const introNames: Record<string, string> = {
  forest: "Forest",
  mountain: "Mountain",
  meteorite: "Meteorite",
  cave: "Crystal Cave",
  beach: "Crimson Beach",
};

export const regionNames: Record<string, string> = {
  ...atollIslandNames,
  ...introNames,
};

export function AtollRegionSymbol(props: { islandId: number | null }) {
  // return an svg with 12 circles equally spaced around a circle,
  // with one of them highlighted according to the islandId

  const svgLength = 48;

  const islandCircles = Array.from(Array(12), (_, i) => (
    <circle
      cx={
        svgLength / 2 +
        (Math.sin((2 * Math.PI * i) / 12 + Math.PI / 18) * svgLength) / 3
      }
      cy={
        svgLength / 2 -
        (Math.cos((2 * Math.PI * i) / 12 + Math.PI / 18) * svgLength) / 3
      }
      r={svgLength / 16}
      fill={
        props.islandId !== null && props.islandId === i ? "#ffee2c" : "#224422"
      }
      stroke="#000000"
      strokeWidth="0.5"
      key={i}
    />
  ));

  return (
    <svg
      width={svgLength}
      height={svgLength}
      viewBox={`0 0 ${svgLength} ${svgLength}`}
      fill="none"
    >
      {islandCircles}
      {props.islandId === null ? (
        <circle
          cx={svgLength / 2}
          cy={svgLength / 2}
          r={svgLength / 5}
          fill="#ffee2c"
        />
      ) : null}
    </svg>
  );
}

export function Region({
  region,
  iconOnly = false,
}: {
  region: string;
  iconOnly?: boolean;
}) {
  const regionInfo: {
    name: string;
    symbol: ReactNode;
  } = (() => {
    const islandId = atollIslandIdMap[region];
    if (islandId !== undefined) {
      return {
        name: "an island",
        symbol: (
          <div className="region-symbol-lower">
            <AtollRegionSymbol islandId={islandId} />
          </div>
        ),
      };
    }
    const introVal = introMap[region];
    const introNameVal = introNames[region];
    if (introVal !== undefined && introNameVal !== undefined) {
      return {
        name: `the ${introNameVal}`,
        symbol: (
          <div className="region-symbol-lower">
            <img src={`/static/images/icons/${introVal}.png`} />
          </div>
        ),
      };
    }
    return {
      name: region,
      symbol: (
        <div className="region-symbol-emoji">
          <Twemoji tag="span">🌊</Twemoji>
        </div>
      ),
    };
  })();

  const regionIcon =
    regionInfo.symbol !== null ? (
      <span className="region-symbol">{regionInfo.symbol}</span>
    ) : null;
  if (iconOnly) return regionIcon;
  return (
    <div className="region-wrapper">
      You found this from: {regionInfo.name} {regionIcon}
    </div>
  );
}
